import { ClaimMessages, TranslationClaimMessages } from "../interfaces";

export const messages : TranslationClaimMessages = {
  [ClaimMessages.access]: "Access",
  [ClaimMessages.activateFutureStatus]: "Activate Future Status",
  [ClaimMessages.activateStatus]: "Activate Status",
  [ClaimMessages.alter]: "Alter",
  [ClaimMessages.changeStatus]: "Change Status",
  [ClaimMessages.changeSupply]: "Change Supply",
  [ClaimMessages.commercialDefault]: "Commercial Default",
  [ClaimMessages.costChangeReminder]: "Cost Change Reminder",
  [ClaimMessages.createCopy]: "Create Copy",
  [ClaimMessages.delete]: "Delete",
  [ClaimMessages.export]: "Export",
  [ClaimMessages.inactivate]: "Inactivate",
  [ClaimMessages.inactivateStatus]: "Inactivate Status",
  [ClaimMessages.include]: "Include",
  [ClaimMessages.print]: "Print",
  [ClaimMessages.technicalDataChangeReminder]: "Technical Data Change Reminder",
  [ClaimMessages.abramsCurveChangeReminder]: "Abrams Curve Change Reminder",
  [ClaimMessages.includeLogo]: "Include Logo",
  [ClaimMessages.deleteLogo]: "Delete Logo",
  [ClaimMessages.download]: "Download",
  [ClaimMessages.alterExternalId]: "Alter External Id",
  [ClaimMessages.changeAllocations]: "Change Allocations",
  [ClaimMessages.dispatch]: "Dispatch",
  [ClaimMessages.reintegrate]: "Reintegrate",
  [ClaimMessages.cancel]: "Cancel",
  [ClaimMessages.requestAdjustment]: "Request Adjustment",
  [ClaimMessages.approveAdjustment]: "Approve Adjustment",
  [ClaimMessages.changeLink]: "Change Link",
  [ClaimMessages.ignoreLink]: "Ignore Link",
  [ClaimMessages.closeInventory]: "Close Inventory",
  [ClaimMessages.closeProduction]: "Close Production",
  [ClaimMessages.reopenProduction]: "Reopen Production",
  [ClaimMessages.alterDelivery]: "Alter Delivery",
  [ClaimMessages.alterPumping]: "Alter Pumping",
  [ClaimMessages.alterScheduling]: "Alter Scheduling",
  [ClaimMessages.approveDisapprovePendingRequests]: "Approve/Disapprove Pending Requests",
  [ClaimMessages.changeDeliveryRoute]: "Change Delivery Route",
  [ClaimMessages.reopenInventory]: "Reopen Inventory",
  [ClaimMessages.dispatchPumpingTicket]: "Dispatch Pumping Ticket",
  [ClaimMessages.waterCut]: "Water Cut",
  [ClaimMessages.sendToAutomation]: "Send to Automation",
  [ClaimMessages.creditLimitWebserviceResendForAnalysis]: "Resend analysis in Credit Limit",
  [ClaimMessages.alertsPageAccess]: "Alerts Page - Access",
  [ClaimMessages.clientPrepaidAlter]: "Client prepaid - Alter",
  [ClaimMessages.constructionNotFoundAlter]: "Construction not found - Alter",
  [ClaimMessages.constructionExpiredAlter]: "Construction expired - Alter",
  [ClaimMessages.schedulingWithoutExternalIdAlter]: "Scheduling without externalId - Alter",
  [ClaimMessages.supplyNotAuthorizedBySecurityVisitAlter]: "Supply not authorized by security visit - Alter",
  [ClaimMessages.productWithoutQuotationAlter]: "Product without quotation - Alter",
  [ClaimMessages.productOrRecipeInactiveAlter]: "Product or recipe inactive - Alter",
  [ClaimMessages.clientDelinquentAlter]: "Client delinquent - Alter",
  [ClaimMessages.clientExpiredCreditDateAlter]: "Client expired credit date - Alter",
  [ClaimMessages.clientWithoutCreditLimitAlter]: "Client without credit limit - Alter",
  [ClaimMessages.waitingCreditLimitAnalysisAlter]: "Waiting credit limit analysis - Alter",
  [ClaimMessages.plantUnavailableAlter]: "Plant unavailable - Alter",
  [ClaimMessages.closeScheduling]: "Close Scheduling",
  [ClaimMessages.reopenScheduling]: "Reopen Scheduling",
  [ClaimMessages.blockReasonCreditLimitValidation]: "Credit limit validation",
  [ClaimMessages.blockReasonCreditLimitAnalysis]: "Waiting for credit limit analysis",
  [ClaimMessages.blockReasonProductGroupRequiresApproval]: "Product group requires approval",
  [ClaimMessages.blockReasonNotSentForAutomation]: "Not sent for automation",
  [ClaimMessages.blockReasonProductRequiresApproval]: "Product requires approval",
  [ClaimMessages.blockReasonProductTypeRequiresApproval]: "Product type requires approval",
  [ClaimMessages.blockReasonSupplyDeviation]: "Supply deviation",
  [ClaimMessages.blockReasonSupplyGroupDeviation]: "Supply group deviation",
  [ClaimMessages.blockReasonMissingAutomationResponse]: "Missing automation response",
  [ClaimMessages.blockReasonInsufficientStock]: "Insufficient stock",
  [ClaimMessages.blockReasonGravelNoLoadReuseParamSet]: "Gravel without defined reuse parameter",
  [ClaimMessages.blockReasonProductGroupNoLoadReuseParamSet]: "Product group without defined reuse parameter",
  [ClaimMessages.blockReasonProductNoLoadReuseParamSet]: "Product without defined reuse parameter",
  [ClaimMessages.blockReasonProductGroupReuseOutOfParams]: "Product group out of reuse parameters",
  [ClaimMessages.blockReasonProductReuseOutOfParams]: "Product out of reuse parameters",
  [ClaimMessages.blockReasonGravelReuseOutOfParams]: "Gravel out of reuse parameters",
  [ClaimMessages.blockReasonDivergentVolume]: "Divergent volume",
  [ClaimMessages.blockReasonWaitingCreditLimitAnalysis]: "Waiting for credit limit analysis",
  [ClaimMessages.blockReasonExpiredCreditDate]: "Expired credit date",
  [ClaimMessages.inconsistencyActualSlump]: "Actual slump",
  [ClaimMessages.inconsistencyConcreteMixerSchedules]: "Concrete mixer schedules",
  [ClaimMessages.inconsistencyWaterAddedInConstruction]: "Water added in construction",
  [ClaimMessages.inconsistencyOdometer]: "Odometer",
  [ClaimMessages.inconsistencyHourMeter]: "HourMeter",
  [ClaimMessages.inconsistencyPumpScheduleWithoutDeliveryTicketPump]: "Schedule with pump without delivery ticket pump",
  [ClaimMessages.inconsistencyPumpScheduleMissingM3ToIssueDelivery]: "Quantity issued differs from the scheduled quantity",
  [ClaimMessages.inconsistencyUndeliveredAndUncancelledSchedules]: "Undelivered and uncancelled schedules",
  [ClaimMessages.inconsistencyUndeliveredAndUncancelledDeliveries]: "Unfulfilled and uncancelled deliveries",
  [ClaimMessages.inconsistencyUnlinkedWeighings]: "Unlinked weighings",
  [ClaimMessages.inconsistencySefazStatusFiscalDocumentNotSend]: "Fiscal document not sent",
  [ClaimMessages.inconsistencySefazStatusFiscalDocumentNoAnswer]: "Fiscal document without response",
  [ClaimMessages.inconsistencySefazStatusFiscalDocumentWithRejection]: "Fiscal document with rejection",
  [ClaimMessages.inconsistencyAdditionalModifications]: "Additional modifications",
  [ClaimMessages.inconsistencyLoadTicketWithoutDeliveryTicket]: "Load ticket without delivery ticket issued",
  [ClaimMessages.inconsistencyLoadReuseWithoutDestination]: "Reuses without specified destination",
  [ClaimMessages.manualEntry]: "Manual Entry",
  [ClaimMessages.viewReports]: "View Reports",
  [ClaimMessages.registerExecution]: "Register Execution",
  [ClaimMessages.updateExecution]: "Update Execution",
  [ClaimMessages.deleteExecution]: "Delete Execution",
  [ClaimMessages.completeTask]: "Complete Task",
  [ClaimMessages.addNotes]: "Add Notes",
  [ClaimMessages.viewPlantStatus]: "View Plant Status",
  [ClaimMessages.viewProduction]: "View Production",
  [ClaimMessages.viewAlarms]: "View Alarms",
  [ClaimMessages.manualCommand]: "Manual Command",
  [ClaimMessages.adjustOrders]: "Adjust Orders",
  [ClaimMessages.acknowledgeAlarm]: "Acknowledge Alarm",
  [ClaimMessages.authorizePrivileged]: "Authorize Privileged",
  [ClaimMessages.manageLocalUsers]: "Manage Local Users",
  [ClaimMessages.viewAudit]: "View Audit",
  [ClaimMessages.plantDefinition]: "Plant Definition",
  [ClaimMessages.alterApplicationOfOwnLabor]: "Alter Application of Own Labor in Pumping",
  [ClaimMessages.adjustedStrength]: "Adjusted rupture result",
  [ClaimMessages.excludeRuptureFromStatistics]: "Exclude rupture from statistics",
  [ClaimMessages.alterProductWeighted]: "Change Recipe to Be Weighed"
};
